<template>
  <div class="color-field">
    <b-col cols="8">
      <FormInput
        v-model="colorsObj[colorCode]"
        :label="label"
        placeholder="#FFFFFF"
        maxlength="7"
      />
    </b-col>
    <b-col cols="1">
      <span class="preview-color">
        <input
          v-model.lazy="colorsObj[colorCode]"
          class="preview-color"
          type="color"
        />
      </span>
    </b-col>
  </div>
</template>

<script>
import FormInput from '@/components/_base/elements/FormInput'

export default {
  name: 'ColorField',

  components: {
    FormInput
  },

  props: {
    /** Label do campo */
    label: {
      type: String,
      default: ''
    },

    /** Objeto contendo todas as cores */
    colorsObj: {
      type: Object,
      default: () => ({})
    },

    /** Código da cor */
    colorCode: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
$circle-size: 23px;

.color-field {
  display: flex;
  align-items: flex-end;

  .preview-color {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $circle-size + 6;
    height: $circle-size + 6;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #000;
    cursor: pointer;

    input[type='color'] {
      width: $circle-size;
      height: $circle-size;
      padding: 0;
      overflow: hidden;
      -webkit-appearance: none;
    }

    input[type='color']::-webkit-color-swatch-wrapper {
      padding: 0;
      background: none;
    }

    input[type='color']::-webkit-color-swatch {
      border: none;
      padding: 0;
    }
  }
}
</style>
